import React from 'react';

interface InputBoxProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  name: string;
  type?: string;
  textarea?: boolean;
  select?: boolean;
  options?: { value: string; label: string }[];
  error?: string;
}

const InputBox = ({
  label,
  required = false,
  placeholder = '',
  value,
  onChange,
  name,
  type = 'text',
  textarea = false,
  select = false,
  options = [],
  error,
}: InputBoxProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    onChange(e);
  };

  return (
    <div className="mb-[40px]">
      <label className="text-2xl md:text-3xl lg:text-xl font-semibold text-[#000000] leading-[120%]">
        {label} {required && <span className="text-[#E43E7A]">*</span>}
      </label>
      {textarea ? (
        <textarea
          name={name}
          required={required}
          className={`w-full border ${error ? 'border-red-500' : 'border-[#D9D9D9]'} rounded-none px-2 md:px-4 py-4 mt-1 min-h-[240px] h-[240px] text-2xl md:text-3xl lg:text-xl font-Regular placeholder-[#BDBDBD] focus:ring-0 focus:border-[#E43E7A] mt-4`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
        />
      ) : select ? (
        <select
          name={name}
          className={`w-full border-0 border-b ${error ? 'border-red-500' : 'border-[#D9D9D9]'} rounded-none px-2 md:px-4 py-4 mt-2 text-2xl md:text-3xl lg:text-xl font-Regular text-gray-700 bg-white focus:ring-0 focus:border-b-[#E43E7A] appearance-none cursor-pointer placeholder-[#BDBDBD]`}
          value={value}
          onChange={handleChange}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value} className={opt.value === '' ? 'text-[#BDBDBD]' : ''}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          name={name}
          type={type}
          required={required}
          className={`w-full border-0 border-b ${error ? 'border-red-500' : 'border-[#D9D9D9]'} rounded-none px-2 md:px-4 py-4 mt-1 text-2xl md:text-3xl lg:text-xl font-Regular placeholder-[#BDBDBD] focus:ring-0 focus:border-b-[#E43E7A]`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
        />
      )}
      {error && (
        <div className="mt-2">
          <p className="text-[#E43E7A] text-base md:text-base font-medium">
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

export default InputBox; 